"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlockPasswordRequest = exports.resetPasswordRequest = exports.tacAuthorizationStatusRetrieve = exports.tacValidateRequest = exports.mfaSendOtp = exports.userVerifyRequest = void 0;
const requestUtil_1 = require("../requestUtil");
const configurations_1 = require("../configurations");
const userVerifyRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_SECURITY + configurations_1.PATH.USER_VERIFY;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.userVerifyRequest = userVerifyRequest;
const mfaSendOtp = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.MFA_SEND_OTP;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.mfaSendOtp = mfaSendOtp;
const tacValidateRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.TAC_VALIDATE;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.tacValidateRequest = tacValidateRequest;
const tacAuthorizationStatusRetrieve = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.TAC_TOKEN_RETRIEVE;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.tacAuthorizationStatusRetrieve = tacAuthorizationStatusRetrieve;
const resetPasswordRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_SECURITY + configurations_1.PATH.RESET_PASSWORD;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.resetPasswordRequest = resetPasswordRequest;
const unlockPasswordRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().CUSTOMER_SECURITY + configurations_1.PATH.UNLOCK_PASSWORD;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.unlockPasswordRequest = unlockPasswordRequest;
